// extracted by css-extract-rspack-plugin
export default {"sidePanel":"sidePanel-wInBl0","formWrapper":"formWrapper-oDoPW6","inputWrapper":"inputWrapper-12JhgE","mustCheckboxes":"mustCheckboxes-kVUkC8"};